var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32636_16843",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32636_16843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 20.4377L24.8829 15.5479H15.1173L20.0001 20.4377ZM28.083 10.2629C28.8176 10.2629 29.4437 10.5216 29.9611 11.0391C30.4785 11.5565 30.7372 12.1825 30.7372 12.9171V29.083C30.7372 29.8176 30.4785 30.4437 29.9611 30.9611C29.4437 31.4785 28.8176 31.7372 28.083 31.7372H11.9171C11.1825 31.7372 10.5565 31.4785 10.0391 30.9611C9.52165 30.4437 9.26294 29.8176 9.26294 29.083V12.9171C9.26294 12.1825 9.52165 11.5565 10.0391 11.0391C10.5565 10.5216 11.1825 10.2629 11.9171 10.2629H28.083ZM11.9171 25.7224V29.083H28.083V25.7224H11.9171ZM28.083 23.0683V12.9171H11.9171V23.0683H28.083Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiClose);
export default __webpack_public_path__ + "static/media/ai-close.0c0ee150738220a34e597d071fe48464.svg";
export { ForwardRef as ReactComponent };